import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import { FileContext } from '../context/file';

export const FileProvider = ({ children }) => {
  const [file, setFile] = useState('');
  const value = useMemo(() => ({ file, setFile }), [file, setFile]);

  return <FileContext.Provider value={value}>{children}</FileContext.Provider>;
};

FileProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
